<template>
  <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <HeaderNav title="小程序备案" v-if="!isMobile"></HeaderNav>
    <div class="top-tips" @click="cReason" v-if="filingInfo.status==5">查看小程序备案驳回原因></div>
    <div class="container">
      <div class="section section-base-info">
        <h3>基础信息</h3>
        <div class="row">
          <div class="row-name">主体性质</div>
          <div class="row-cont">
            <el-select v-model="subject_base_info.type" class="row-cont-select">
              <el-option
                v-for="item in subjectTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="row-name">主办单位名称</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_base_info.name" @input="subject_base_info.name=infoTrimSpecial(subject_base_info.name)" class="row-cont-input" />
          </div>
        </div>
        <div class="row input-group input-group-area">
          <div class="row-col">
            <div class="row-name">备案地址</div>
            <!-- <span class="iconfont icon-position" @click="isShowMap = true" v-if="!isMobile"></span> -->
          </div>
          <div class="area-box" v-if="isMobile">
            <div class="area-input" @click="clickProvincesTap">
              <span class="area-txt">{{chooseCity}}</span>
              <span class="iconfont icon-triangle"></span>
            </div>
            <!-- <div class="map-btn" @click="isShowMap = true">
              <span class="iconfont icon-position"></span>
            </div> -->
          </div>
          <div class="area-select-box" v-else> 
            <!-- <p class="area-info" v-if="chooseCity">{{chooseCity}}</p>  @change="getProvince($event)" getCity  getArea -->
            <el-select v-model="subject_base_info.province" class="area-select-box-select" placeholder="请选择省份" @change="provinceChange">
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
            <el-select v-model="subject_base_info.city" class="area-select-box-select" placeholder="请选择市" @change="cityChange($event)">
              <el-option
                v-for="item in cityList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
            <el-select v-model="subject_base_info.district" class="area-select-box-select" placeholder="请选择区" @change="districtChange($event)">
              <el-option
                v-for="item in areaList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
            <!-- <el-select v-model="subject_base_info.street" class="area-select-box-select" placeholder="请选择街道" @change="getStreet($event)">
              <el-option
                v-for="item in streetList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select> -->
          </div>
        </div>
        <div class="row">
          <div class="row-name">详细地址</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_base_info.address" @input="subject_base_info.address=infoTrimSpecial(subject_base_info.address)" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">备注</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_base_info.comment" @input="subject_base_info.comment=infoTrimSpecial(subject_base_info.comment)" class="row-cont-input" />
          </div>
        </div>
      </div>
      <div class="section">
        <h3>其他信息</h3>
        <div class="row">
          <div class="row-name">主体证件类型</div>
          <div class="row-cont">
            <el-select v-model="subject_organize_info.certificate_type" class="row-cont-select">
              <el-option
                v-for="item in icpCertificateTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row" v-show="subject_organize_info.certificate_type">
          <div class="row-name">上传营业执照</div>
          <div class="row-cont">
            <VantUploadImg-License name="" :shopCode="shopCode" :type="subject_organize_info.certificate_type" orderField="icp_subject.organize_info.certificate_photo" :value="licenseImg" @valChange="getlicenseImages" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">主体证件号码</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_organize_info.certificate_number" @input="inputNumber"  class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">主体证件住所</div>
          <div class="row-cont">
            <el-input type="textarea" placeholder="输入" :rows="4" v-model="subject_organize_info.certificate_address" @input="inputAddress" class="row-cont-input row-cont-textarea" />
          </div>
        </div>
      </div>
      <div class="section">
        <h3>负责人信息</h3>
        <div class="row">
          <div class="row-name">负责人姓名</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_principal_info.name" maxlength="20" @input="inputName" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">联系方式</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_principal_info.mobile" maxlength="13" @input="inputMobile" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">电子邮件</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_principal_info.email" maxlength="50" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">应急联系方式</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_principal_info.emergency_contact" maxlength="13" @input="inputContact" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-name">负责人证件类型</div>
          <div class="row-cont">
            <el-select v-model="subject_principal_info.certificate_type" class="row-cont-select">
              <el-option
                v-for="item in icpCertificateTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="row-cont row-cont-col" v-show="subject_principal_info.certificate_type">
            <div class="row-cont-img">
              <div class="row-name">上传证件头像面</div>
              <VantUploadImg-Front name="" :shopCode="shopCode" :type="subject_principal_info.certificate_type" orderField="icp_subject.principal_info.certificate_photo_front" :value="subCardHeadImg" @valChange="getSubHeadImages" />
            </div>
            <div class="row-cont-img">
              <div class="row-name">上传证件国徽面</div>
              <VantUploadImg-Back name="" :shopCode="shopCode" :type="subject_principal_info.certificate_type" orderField="icp_subject.principal_info.certificate_photo_back" :value="subCardBackImg" @valChange="getSubBackImages" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-name">证件号码</div>
          <div class="row-cont">
            <input type="text" placeholder="输入" v-model="subject_principal_info.certificate_number" maxlength="30" @input="subject_principal_info.certificate_number=checkNumAndLetters(subject_principal_info.certificate_number)" class="row-cont-input" />
          </div>
        </div>
        <div class="row">
          <div class="row-top">
            <div class="row-name">有效期</div>
            <div class="row-top-radio" @click="cSubLongTerm">
              <span class="iconfont icon" :class="isSubLongTerm==1?'icon-a-Selectone':'icon-a-noSelected'"></span>长期有效
            </div>
          </div>
          <div class="row-cont">
            <!-- <div class="row-cont-date" v-if="isMobile">
              <div class="row-cont-date-time row-cont-date-empty row-cont-date-picker" @click="openCardTime(1)">{{form.startTime||'开始日期'}}</div>
              <div class="ctn">至</div>
              <div class="row-cont-date-empty row-cont-date-picker" @click="openCardTime(2)">{{form.endtTime||'结束日期'}}</div>
            </div> -->
            <div class="row-cont-date">
              <el-date-picker class="row-cont-date-picker"
                v-model="subject_principal_info.certificate_validity_date_start"
                type="date"
                :clearable="false"
                placeholder="开始日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <div class="ctn">至</div>
              <el-date-picker class="row-cont-date-picker"
                v-model="subject_principal_info.certificate_validity_date_end"
                type="date"
                :clearable="false"
                placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :disabled="isSubLongTerm==1?true:false">
              </el-date-picker>
            </div>
          </div>
          <!-- <VantDatetimePicker-IdCard name="证件有效期" :showPopup="isShowIdCard" @isShow="isShowIdCard = false" @open="isShowIdCard = true" @dateInput="idCardDateChange" /> -->
        </div>
        <div class="row" style="margin-bottom: 40px;">
          <div class="row-name">法定代表人授权书</div>
          <VantUploadImg-Front name="" :shopCode="shopCode" orderField="icp_subject.principal_info.authorization_letter" :value="authImg" @valChange="getAuthImages" />
        </div>
        <div class="section section-wechat">
          <h3>微信小程序信息</h3>
          <div class="row">
            <div class="row-cont">
              <div class="row-cont-label">APPID</div>
              <div class="row-cont-info">{{shopInfo.appletsId||'-'}}</div>
            </div>
            <div class="row-cont">
              <div class="row-cont-label">小程序名称</div>
              <div class="row-cont-info">{{shopInfo.appletsName}}</div>
            </div>
          </div>
          <div class="row">
            <div class="row-name">服务内容标识</div>
            <div class="row-cont">
              <el-select v-model="service_content_types" multiple class="row-cont-select">
                <el-option
                  v-for="item in icpServiceContentTypes"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="row-name">互联网信息服务前置审批项</div>
            <div class="row-cont">
              <el-select v-model="nrlx_details" multiple filterable filterablex class="row-cont-select">
                <el-option
                  v-for="item in icpNrlxTypes"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="row-name">备注</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="comment" @input="comment=infoTrimSpecial(comment)" class="row-cont-input" />
            </div>
          </div>
        </div>
        <div class="section">
          <h3>小程序负责人信息</h3>
          <div class="row">
            <div class="row-name">负责人姓名</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="applets_principal_info.name" maxlength="20" @input="inputAppletsName" class="row-cont-input" />
            </div>
          </div>
          <div class="row">
            <div class="row-name">联系方式</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="applets_principal_info.mobile" maxlength="13" @input="inputAppletsMobile" class="row-cont-input" />
            </div>
          </div>
          <div class="row">
            <div class="row-name">电子邮件</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="applets_principal_info.email" maxlength="50" class="row-cont-input" />
            </div>
          </div>
          <div class="row">
            <div class="row-name">应急联系方式</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="applets_principal_info.emergency_contact" maxlength="13" @input="inputAppletsContact" class="row-cont-input" />
            </div>
          </div>
          <div class="row">
            <div class="row-name">负责人证件类型</div>
            <div class="row-cont">
              <el-select v-model="applets_principal_info.certificate_type" class="row-cont-select">
                <el-option
                  v-for="item in icpCertificateTypes"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="row-cont row-cont-col" v-show="applets_principal_info.certificate_type">
              <div class="row-cont-img">
                <div class="row-name">上传证件头像面</div>
                <VantUploadImg-Front name="" :shopCode="shopCode" :type="applets_principal_info.certificate_type" orderField="icp_applets.principal_info.certificate_photo_front" :value="cardHeadImg" @valChange="getHeadImages" />
              </div>
              <div class="row-cont-img">
                <div class="row-name">上传证件国徽面</div>
                <VantUploadImg-Back name="" :shopCode="shopCode" :type="applets_principal_info.certificate_type" orderField="icp_applets.principal_info.certificate_photo_back" :value="cardBackImg" @valChange="getBackImages" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row-name">证件号码</div>
            <div class="row-cont">
              <input type="text" placeholder="输入" v-model="applets_principal_info.certificate_number" maxlength="30" @input="applets_principal_info.certificate_number=checkNumAndLetters(applets_principal_info.certificate_number)" class="row-cont-input" />
            </div>
          </div>
          <div class="row">
            <div class="row-top">
              <div class="row-name">有效期</div>
              <div class="row-top-radio" @click="cLongTerm">
                <span class="iconfont icon" :class="isLongTerm==1?'icon-a-Selectone':'icon-a-noSelected'"></span>长期有效
              </div>
            </div>
            <div class="row-cont">
              <!-- <div class="row-cont-date" v-if="isMobile">
                <div class="row-cont-date-time row-cont-date-empty row-cont-date-picker" @click="openCardTime(1)">{{form.startTime||'开始日期'}}</div>
                <div class="ctn">至</div>
                <div class="row-cont-date-empty row-cont-date-picker" @click="openCardTime(2)">{{form.endtTime||'结束日期'}}</div>
              </div> -->
              <div class="row-cont-date">
                <el-date-picker class="row-cont-date-picker"
                  v-model="applets_principal_info.certificate_validity_date_start"
                  type="date"
                  :clearable="false"
                  placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
                <div class="ctn">至</div>
                <el-date-picker class="row-cont-date-picker"
                  v-model="applets_principal_info.certificate_validity_date_end"
                  type="date"
                  :clearable="false"
                  placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="isLongTerm==1?true:false">
                </el-date-picker>
              </div>
            </div>
            <!-- <VantDatetimePicker-IdCard name="证件有效期" :showPopup="isShowIdCard" @isShow="isShowIdCard = false" @open="isShowIdCard = true" @dateInput="idCardDateChange" /> -->
          </div> 
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer footer-btns">
      <div class="submit-btn" @click="submitFilings" v-if="filingInfo.status!=2">确定</div>
      <div class="submit-btn" @click="submitRevoke" v-else>撤销</div>
      <!-- <router-link :to="{path: '/auth-succes?shopCode='+shopCode}" class="jump-btn">跳过</router-link> -->
    </div>

    <ContactBtn />

    <!-- 列表展示 -->
    <section class="showAddressList">
        <van-action-sheet v-model="showList">
            <div class="titleBox">
                <p></p>
                <p class="title">所在地区</p>
                <p class="confirm" @click="showList = false">取消</p>
            </div>
            <!-- 省市区街道的标题 -->
            <div class="showAddress bd">
                <div class="showArea minVideoViewBox">
                    <p class="tipTxt" @click="chooseProvince" v-show='tit1'>{{chooseTit1}}</p>
                    <p class="tipTxt" @click="chooseCitys" v-show='tit2'>{{chooseTit2}}</p>
                    <p class="tipTxt" @click="chooseArea" v-show='tit3'>{{chooseTit3}}</p>
                    <p class="tipTxt" @click="chooseStreet" v-show='tit4'>{{chooseTit4}}</p>
                </div>
            </div>
            <div class="title-bar"></div>
            <!-- 省市区街道的标题 -->
            <div class="chooseList">
                <!-- 省市区列表 --->
                <div class="addressList">
                    <ul v-show="showProvince">
                        <li v-for="(item, index) in provinceList" :key="index" @click="getProvince(item, index)">
                            <div class="items">
                                <div>{{item.name}}</div>
                                <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon1 == index}"></div>
                            </div>
                        </li>
                    </ul>
                    <ul v-show="showCity">
                        <li v-for="(item, index) in cityList" :key="index" @click="getCity(item, index)">
                            <div class="items">
                                <div>{{item.name}}</div>
                                <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon2 == index}"></div>
                            </div>
                        </li>
                    </ul>
                    <ul v-show="showArea">
                        <li v-for="(item, index) in areaList" :key="index" @click="getArea(item, index)">
                            <div class="items">
                                <div>{{item.name}}</div>
                                <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon3 == index}"></div>
                            </div>
                        </li>
                    </ul>
                    <!-- <ul v-show="showStreet">
                        <li v-for="(item, index) in streetL" :key="index" @click="getStreet(item, index)">
                            <div class="items">
                                <div>{{item.name}}</div>
                                <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon4 == index}"></div>
                            </div>
                        </li>
                    </ul> -->
                </div>
            </div>
        </van-action-sheet>
    </section>

    <van-popup class="reason-modal"
      v-model:show="showCenter" round>
      <div class="form-cont">
        <div class="reason">
          <div class="reason-label">驳回原因：</div>
          <div class="reason-cont">{{filingInfo.reason}}</div>
        </div>
        <div class="reason" v-if="filingInfo.suggest&&filingInfo.suggest!=''">
          <div class="reason-label">修改建议：</div>
          <div class="reason-cont">{{filingInfo.suggest}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>


<script>
import VantMediaUploadImg from '@/components/VantMediaUploadImg.vue';
import VantDatetimePicker from '@/components/VantDatePicker.vue';
import { getProvinceByName, getCityByName, getAreaByName, getStreetByName, getProvince, getCity, getArea, getStreet, shopBasic, mallBasic, getAnnualFeeInfo } from '@/api/baseinfo';
import { getWxStteing,queryIcpSubjectTypes,queryIcpCertificateTypes,queryIcpServiceContentTypes,queryIcpDistrictCode,queryIcpNrlxTypes,uploadIcpMedia,getOnlineIcpOrder,createIcpVerifyTask,applyIcpFiling,cancelApplyIcpFiling,getIcpEntranceInfo } from '@/api/register';
export default {
  components: {
    'VantUploadImg-License': VantMediaUploadImg,
    'VantUploadImg-Front': VantMediaUploadImg,
    'VantUploadImg-Back': VantMediaUploadImg,
    'VantDatetimePicker-License': VantDatetimePicker,
    'VantDatetimePicker-IdCard': VantDatetimePicker
  },
  data () {
    return {
      shopCode: undefined,
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      labelNo:1,
      labelList:[{name:'送1个月',value:1},{name:'送2个月',value:2},{name:'送3个月',value:3}],
      // 省市区
      chooseCity: "请选择",
      provinceL: [], //省数据列表
      cityL: [],
      areaL: [],
      streetL: [],
      showProvince: true, //是否显示模块
      showCity: false,
      showArea: false,
      showStreet: false,
      chooseTit1: "请选择省", //占位
      chooseTit2: "请选择市",
      chooseTit3: "请选择区",
      chooseTit4: "请选择街道",
      tit1: true, //切换标题
      tit2: false,
      tit3: false,
      tit4: false,
      province: "", //当前选择值
      Nextcity: "",
      district: "",
      street: "",
      currentType: 1, //当前操作类型 1:省:，2:市，3：区，4：街道
      parentId: 1, //父级id
      currentAdsId: '', //当前选择地址id
      showList: false, //显示地址列表
      activeIcon1: -1, //省 icon状态
      activeIcon2: -1,
      activeIcon3: -1,
      activeIcon4: -1,
      contractNameValid: false,
      propertyInfo: {},  // 是否自营、有无实体
      industryInfo: {},
      //////////
      isCardLong: false,
      isShowIdCard: false,
      cardTimeType:0,
      form: {},
      ////////////////
      filingDialogVisible:false,
      subjectTypes:[],
      icpCertificateTypes:[],
      icpDistrictCode:[],
      icpServiceContentTypes:[],
      icpNrlxTypes:[],
      ///////
      shopInfo:{},
      nrlx_details:[],
      service_content_types:[],
      isLongTerm:0,
      cardHeadImg:[],
      cardBackImg:[],
      applets_principal_info:{
        certificate_number:'',
        certificate_photo_back:'',
        certificate_photo_front:'',
        certificate_type:null,
        certificate_validity_date_end:'',   //请填写 "长期"，示例值："20330815"		false	
        certificate_validity_date_start:'',	 // 负责人证件有效期起始日期，格式为 YYYYmmdd		false	
        email:'',
        emergency_contact:'',
        mobile:'',
        name:'',
      },
      icpDistrictCodelist:[],
      provinceList:[],
      cityList:[],
      areaList:[],
      streetList:[],
      subject_base_info:{
        province:'',
        city:'',
        district:'',
        address:'',
        name:'',
        type:'',
        comment: ''
      },
      subject_organize_info:{
        certificate_address:'',
        certificate_number:'',
        certificate_type:null,
        certificate_license:''
      },
      isSubLongTerm:0,
      subCardHeadImg:[],
      subCardBackImg:[],
      licenseImg:[],
      authImg: [],
      subject_principal_info:{
        certificate_number:'',
        certificate_photo_back:'',
        certificate_photo_front:'',
        certificate_type:null,
        certificate_validity_date_end:'',   //请填写 "长期"，示例值："20330815"		false	
        certificate_validity_date_start:'',	 // 负责人证件有效期起始日期，格式为 YYYYmmdd		false	
        email:'',
        emergency_contact:'',
        mobile:'',
        name:'', 
      },
      showCenter:false,
      filingInfo:{
        status: null,
        reason: '',
        suggest: ''
      },
      comment: ''
    }
  },
  created() {
    this.shopCode = this.$route.query ? this.$route.query.shopCode : undefined;
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
    this.getWxStteing();
    this.queryIcpSubjectTypes();
    this.queryIcpCertificateTypes();
    this.queryIcpServiceContentTypes();
    this.queryIcpNrlxTypes();
    this.queryIcpDistrictCode();
    this.getIcpEntranceInfo();
    this.getOnlineIcpOrder();
    this.createIcpVerifyTask();
    // this.uploadIcpMedia();   //上传
  },
  methods: {
    getWxStteing() {
      getWxStteing({shopCode: this.shopCode}).then(res => {
        this.shopInfo = res.data;
      })
    },
    getOnlineIcpOrder(){
      getOnlineIcpOrder({shopCode:this.shopCode}).then(res=>{
        let data = res.data;
        if(res.code===200&&data){
          if(data.icp_applets){
            if(data.icp_applets.base_info){
              if(data.icp_applets.base_info.nrlx_details&&data.icp_applets.base_info.nrlx_details.length>0){
                data.icp_applets.base_info.nrlx_details.map(item=>{
                  this.nrlx_details.push(item);
                })
              }
              this.service_content_types = data.icp_applets.base_info.service_content_types?data.icp_applets.base_info.service_content_types:[];
              this.comment = data.icp_applets.base_info.comment?data.icp_applets.base_info.comment:'';
            }
            if(data.icp_applets.principal_info){
              this.applets_principal_info = data.icp_applets.principal_info;
              this.isLongTerm = data.icp_applets.principal_info.certificate_validity_date_end==='长期'?1:0;
              if(data.icp_applets.principal_info.certificate_photo_front&&data.icp_applets.principal_info.certificate_photo_front!==''){
                this.cardHeadImg = [{url:'',media_id: data.icp_applets.principal_info.certificate_photo_front}];
              } else {
                this.cardHeadImg = [];
              }
              if(data.icp_applets.principal_info.certificate_photo_back&&data.icp_applets.principal_info.certificate_photo_back!==''){
                this.cardBackImg = [{url:'',media_id: data.icp_applets.principal_info.certificate_photo_back}];
              } else {
                this.cardBackImg = [];
              }
            }
          }
          if(data.icp_subject){
            if(data.icp_subject.base_info){
              this.subject_base_info = data.icp_subject.base_info;
            }
            if(data.icp_subject.organize_info){
              this.subject_organize_info = data.icp_subject.organize_info;
              if(data.icp_subject.organize_info.certificate_photo&&data.icp_subject.organize_info.certificate_photo!==''){
                this.licenseImg = [{url:'',media_id: data.icp_subject.organize_info.certificate_photo}];
              } else {
                this.licenseImg = [];
              }
            }
            if(data.icp_subject.principal_info){
              this.subject_principal_info = data.icp_subject.principal_info;
              this.isSubLongTerm = data.icp_subject.principal_info.certificate_validity_date_end==='长期'?1:0;
              if(data.icp_subject.principal_info.certificate_photo_front&&data.icp_subject.principal_info.certificate_photo_front!==''){
                this.subCardHeadImg = [{url:'',media_id: data.icp_subject.principal_info.certificate_photo_front}];
              } else {
                this.subCardHeadImg = [];
              }
              if(data.icp_subject.principal_info.certificate_photo_back&&data.icp_subject.principal_info.certificate_photo_back!==''){
                this.subCardBackImg = [{url:'',media_id: data.icp_subject.principal_info.certificate_photo_back}];
              } else {
                this.subCardBackImg = [];
              }
            }
            if(data.icp_subject.principal_info.authorization_letter&&data.icp_subject.principal_info.authorization_letter!==''){
              this.authImg = [{url:'',media_id: data.icp_subject.principal_info.authorization_letter}];
            } else {
              this.authImg = [];
            }
          }
        }
      })
    },
    getIcpEntranceInfo(){
      getIcpEntranceInfo({shopCode:this.shopCode}).then(res=>{
        if(res.data&&res.data.info){
          this.filingInfo.status = res.data.info.status;
          this.filingInfo.reason = res.data.info.audit_data.error;
          this.filingInfo.suggest = res.data.info.audit_data.suggest;
        }
      })
    },
    queryIcpSubjectTypes(){
      queryIcpSubjectTypes({shopCode:this.shopCode}).then(res=>{
        this.subjectTypes = res.data.items;
      })
    },
    queryIcpCertificateTypes(){
      queryIcpCertificateTypes({shopCode:this.shopCode}).then(res=>{
        this.icpCertificateTypes = res.data.items;
      })
    },
    queryIcpServiceContentTypes(){
      queryIcpServiceContentTypes({shopCode:this.shopCode}).then(res=>{
        this.icpServiceContentTypes = res.data.items;
      })
    },
    queryIcpNrlxTypes(){
      queryIcpNrlxTypes({shopCode:this.shopCode}).then(res=>{
        this.icpNrlxTypes = res.data.items;
      })
    },
    // 省市区
    queryIcpDistrictCode(){
      queryIcpDistrictCode({shopCode:this.shopCode}).then(res=>{
        this.provinceList = res.data.items;
        this.icpDistrictCodelist = res.data.items;
      })
    },
    provinceChange(){
      if(this.icpDistrictCodelist.length>0){
        let arr = this.icpDistrictCodelist.filter(v=>{return v.code==this.subject_base_info.province||v.code==this.subject_base_info.province})||[];
        this.subject_base_info.city=null;
        this.subject_base_info.district=null;
        this.cityList = arr[0].sub_list;
        if(this.isMobile){
          this.handleByType(this.cityList);
        }
      }
    },
    cityChange(){
      if(this.icpDistrictCodelist.length>0){
        let arr = this.cityList.filter(v=>{return v.code==this.subject_base_info.city||v.code==this.subject_base_info.city})||[];
        this.subject_base_info.district=null;
        this.areaList = arr[0].sub_list;
        if(this.isMobile){
          this.handleByType(this.areaList);
          this.tit3 = true;
        }
      }
    },
    inputNumber(e){
      this.subject_organize_info.certificate_number=this.checkNumAndLetters(this.subject_organize_info.certificate_number);
      this.subject_organize_info.certificate_number = e.target.value;
    },
    inputAddress(e){
      this.subject_organize_info.certificate_address=this.infoTrimSpecial(this.subject_organize_info.certificate_address);
      this.subject_organize_info.certificate_address = e.target.value;
    },
    inputName(e){
      this.subject_organize_info.name=this.trimSpecial(this.subject_organize_info.name);
      this.subject_organize_info.name = e.target.value;
    },
    inputMobile(e){
      this.subject_organize_info.mobile=this.checkNumber(this.subject_organize_info.mobile);
      this.subject_organize_info.mobile = e.target.value;
    },
    inputContact(e){
      this.subject_principal_info.emergency_contact=this.checkNumber(this.subject_principal_info.emergency_contact);
      this.subject_principal_info.emergency_contact= e.target.value;
    },
    inputAppletsName(e){
      this.applets_principal_info.name=this.trimSpecial(this.applets_principal_info.name);
      this.applets_principal_info.name = e.target.value;
    },
    inputAppletsMobile(e){
      this.applets_principal_info.mobile=this.checkNumber(this.applets_principal_info.mobile);
      this.applets_principal_info.mobile = e.target.value;
    },
    inputAppletsContact(e){
      this.applets_principal_info.emergency_contact=this.checkNumber(this.pplets_principal_info.emergency_contact);
      this.pplets_principal_info.emergency_contact = e.target.value;
    },
    districtChange(){
      // this.handleByType(this.areaList);
    },
    cSubLongTerm(){
      this.isSubLongTerm=this.isSubLongTerm==1?0:1
      this.subject_principal_info.certificate_validity_date_end=this.isSubLongTerm==1?'':this.subject_principal_info.certificate_validity_date_end;
    },
    cLongTerm(){
      this.isLongTerm=this.isLongTerm==1?0:1
      this.applets_principal_info.certificate_validity_date_end=this.isLongTerm==1?'':this.subject_principal_info.certificate_validity_date_end;
    },
    getHeadImages(files){
      if(files&&files.length>0){
        this.cardHeadImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.applets_principal_info.certificate_photo_front=files&&files.length>0?files[0].media_id:'';
    },
    getBackImages(files){
      if(files&&files.length>0){
        this.cardBackImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.applets_principal_info.certificate_photo_back=files&&files.length>0?files[0].media_id:'';
    },
    getSubHeadImages(files){
      if(files&&files.length>0){
        this.subCardHeadImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.subject_principal_info.certificate_photo_front=files&&files.length>0?files[0].media_id:'';
    },
    getSubBackImages(files){
      if(files&&files.length>0){
        this.subCardBackImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.subject_principal_info.certificate_photo_back=files&&files.length>0?files[0].media_id:'';
    },
    getlicenseImages(files){
      if(files&&files.length>0){
        this.licenseImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.subject_organize_info.certificate_photo=files&&files.length>0?files[0].media_id:'';
    },
    getAuthImages(files){
      if(files&&files.length>0){
        this.authImg = [{url:files[0].url, media_id:files[0].media_id}]
      }
      this.subject_principal_info.authorization_letter=files&&files.length>0?files[0].media_id:'';
    },
    cReason(){
      this.showCenter = true;
    },
    openCardTime(type){
      this.cardTimeType=type;
      this.isShowIdCard=true;
    },
    idCardDateChange(datetime){
      if(this.cardTimeType==1){
        this.form.startTime = datetime;
      } else{
        this.form.endtTime = datetime;
      }
    },
    toPrev() {
      this.$router.go(-1);
    },
    // 点击选择 省市区 展示弹窗
    clickProvincesTap() {
      this.showList = true;
      this.showProvince = true;
      //this.getProvinceList();
    },
    ///////////<!-- 选择省市区街道事件 -->
    //当用户点击某个省事件 根据省的id获取市
    getProvince(item, index) {
      if(this.isMobile) {
        this.province = item.name;
        this.chooseTit1 = item.name;
        this.activeIcon1 = index; //当前选中icon
        this.currentType = 2;
        this.subject_base_info.province = item.code;
        // this.getCityList(item.code);
        this.provinceChange();
        // chooseTit1: "请选择省", //占位
        this.chooseTit2 = "请选择市";
        this.chooseTit3 = "请选择区";
        this.chooseTit4 = "请选择街道";
      } else {
        let idx = this.provinceList.map(f => f.code).indexOf(item);
        this.province = this.provinceList[idx].name;
        this.subject_base_info.province = item;
        this.subject_base_info.city = undefined;
        this.subject_base_info.district = undefined;
        this.form.shopStreet = undefined;
        // this.getCityList(item);
        this.cityChange();
      }
      sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
    },
    //当用户点击某个市事件 根据市的id获取区
    getCity(item, index) {
      if(this.isMobile) {
        this.Nextcity = item.name;
        this.chooseTit2 = item.name;
        this.activeIcon3 = -1; //重置icon状态
        this.activeIcon2 = index; //当前选中icon
        this.currentType = 3;
        this.subject_base_info.city = item.code;
        this.cityChange();
        // this.getAreaList(item.code);
        this.chooseTit3 = "请选择区";
        this.chooseTit4 = "请选择街道";
      } else {
        let idx = this.cityList.map(f => f.code).indexOf(item);
        this.Nextcity = this.cityList[idx].name;
        this.subject_base_info.city = item;
        this.subject_base_info.district = undefined;
        this.form.shopStreet = undefined;
        this.cityChange();
        // this.getAreaList(item);
      }
      sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
      this.isShowList();
    },
    //当用户点击某个区事件 根据区的id获取街道
    getArea(item, index) {
      if(this.isMobile) {
        this.district = item.name;
        this.chooseTit3 = item.name;
        this.activeIcon4 = -1;
        this.activeIcon3 = index;
        this.currentType = 4;
        this.subject_base_info.district = item.code;
        // this.getStreetList(item.code);
        this.chooseTit4 = "请选择街道";
      } else {
        let idx = this.areaList.map(f => f.code).indexOf(item);
        this.district = this.areaList[idx].name;
        this.subject_base_info.district = item;
        this.form.shopStreet = undefined;
        // this.getStreetList(item);
      }
      this.showList = false;
      this.showProvince = false;
      sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
      this.isShowList();
    },
    //用户点击镇，隐藏弹窗
    getStreet(item, index) {
      if(this.isMobile) {
        this.street = item.name;
        this.chooseTit4 = item.name;
        this.activeIcon4 = index;
        this.form.shopStreet = item.code;
      } else {
        let idx = this.streetList.map(f => f.code).indexOf(item);
        this.street = this.streetList[idx].name;
        this.form.shopStreet = item;
      }
      sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
      this.isShowList();
      this.showList = false;
    },
    //弹窗消失 保存当前选择值
    isShowList() {
      let totalCity = '';
      if(this.isMobile) {
        totalCity = `${this.province}${this.Nextcity}${this.district}${this.street}`;
      } else {
        totalCity = `${this.province}，${this.Nextcity}，${this.district}，${this.street}`;
      }
      this.chooseCity = totalCity;
      // this.showList = false;
      let areaInfo = {
        province: this.province,
        Nextcity: this.Nextcity,
        district: this.district,
        street: this.street
      }
      sessionStorage.setItem('areaInfo', JSON.stringify(areaInfo));
    },
    //点击省市区标题显示/隐藏相关内容 形成回退效果
    chooseProvince() {
        this.showProvince = true;
        this.showCity = false;
        this.showArea = false;
        this.showStreet = false;
        this.activeIcon2 = -1; //重置
        if(this.tit1 && this.subject_base_info.province) this.provinceChange();
        // if(this.tit1 && this.subject_base_info.province) this.getProvinceList();
    },
    chooseCitys() { //选择市
        this.showProvince = false;
        this.showCity = true;
        this.showArea = false;
        this.showStreet = false;
        this.activeIcon3 = -1; //重置
        if(this.tit2 && this.subject_base_info.province) this.cityChange();
        // if(this.tit2 && this.subject_base_info.province) this.getCityList(this.subject_base_info.province);
    },
    chooseArea() { //选择区
        this.showProvince = false;
        this.showCity = false;
        this.showArea = true;
        this.showStreet = false;
        // if(this.tit3 && this.subject_base_info.city) this.getAreaList(this.subject_base_info.city);
    },
    chooseStreet() { //选择街道
      this.showProvince = false;
      this.showCity = false;
      this.showArea = false;
      this.showStreet = true;
      // if(this.tit4 && this.subject_base_info.district) this.getStreetList(this.subject_base_info.district);
    },
    // getProvinceList() {
    //   getProvince().then(res => {
    //     res.data.forEach((item, index) => {
    //       if(item.code == this.subject_base_info.province) {
    //         this.activeIcon1 = index;
    //       }
    //     })
    //     this.provinceList = res.data;
    //   })
    // },
    // getCityList(code) {
    //   getCity(code).then(res => {
    //     res.data.forEach((item, index) => {
    //       if(item.code == this.subject_base_info.city) {
    //         this.activeIcon2 = index;
    //       }
    //     })
    //     this.cityList = res.data;
    //     this.handleByType(res.data);
    //   })
    // },
    // getAreaList(code) {
    //   getArea(code).then(res => {
    //     res.data.forEach((item, index) => {
    //       if(item.code == this.subject_base_info.district) {
    //         this.activeIcon3 = index;
    //       }
    //     })
    //     this.areaList = res.data;
    //     this.handleByType(res.data);
    //   })
    // },
    // getStreetList(code) {
    //   getStreet(code).then(res => {
    //     res.data.forEach((item, index) => {
    //       if(item.code == this.form.shopStreet) {
    //         this.activeIcon4 = index;
    //       }
    //     })
    //     this.streetList = res.data;
    //     this.handleByType(res.data);
    //   })
    // },
    //根据当前操作类型处理数据
    handleByType(datas) {
      if(!this.isMobile) return;
      if(datas.length == 0) {
          this.isShowList();
          return;
      }
      switch(this.currentType) {
        case 1: //省
            this.provinceList = datas;
            break;
        case 2: //市
            this.cityList = datas;
            this.citySelected = this.cityList[0].id;
            this.showProvince = false;
            this.showCity = true;
            this.tit2 = true;
            this.areaList = [];
            break;
        case 3: //区
            this.areaList = datas;
            this.areaSelected = this.areaList[0].id;
            this.showCity = false;
            this.showArea = true;
            this.tit3 = true;
            this.streetList = [];
            break;
        case 4: //街道
            this.streetList = datas;
            this.streetSelected = this.streetList[0].id;
            this.showCity = false;
            this.showArea = false;
            this.showStreet = true;
            this.tit4 = true;
            break;
      }
    },
    createIcpVerifyTask(){
      createIcpVerifyTask({shopCode: this.shopCode}).then(res=>{})
    },
    submitFilings(){
      if(!this.subject_base_info.type||this.subject_base_info.type==='') return this.Toast('请选择主体性质~');
      if(!this.subject_base_info.name||this.subject_base_info.name==='') return this.Toast('请输入主体名称~');
      if(!this.subject_base_info.province||this.subject_base_info.province===''||this.subject_base_info.city===''||this.subject_base_info.district==='') return this.Toast('请选择备案地址~');
      if(!this.subject_base_info.address||this.subject_base_info.address==='') return this.Toast('请输入详情地址~');

      if(!this.subject_organize_info.certificate_type) return this.Toast('请选择其他信息-主体证件类型~');
      if(this.licenseImg.length<1) return this.Toast('请上传主体证件照片~');

      if(!this.subject_organize_info.certificate_number||this.subject_organize_info.certificate_number==='') return this.Toast('请输入其他信息-主体证件号码~');
      if(!this.subject_organize_info.certificate_number||this.subject_organize_info.certificate_number==='') return this.Toast('请输入其他信息-主体证件住所~');

      if(!this.subject_principal_info.name||this.subject_principal_info.name==='') return this.Toast('请输入负责人姓名~');
      if(!this.subject_principal_info.mobile||this.subject_principal_info.mobile==='') return this.Toast('请输入负责人联系方式~');
      if(!this.subject_principal_info.email||this.subject_principal_info.email==='') return this.Toast('请输入负责人电子邮件~');
      if(!this.subject_principal_info.emergency_contact||this.subject_principal_info.emergency_contact==='') return this.Toast('请输入负责人应急联系方式~');
      if(!this.subject_principal_info.certificate_type) return this.Toast('请选择负责人的证件类型~');
      if(!this.subject_principal_info.certificate_number||this.subject_principal_info.certificate_number==='') return this.Toast('请输入负责人的证件号码~');
      if(this.subCardHeadImg.length<1||this.subCardBackImg.length<1) return this.Toast('请上传负责人的证件照片~');
      if(!this.subject_principal_info.certificate_photo_front||this.subject_principal_info.certificate_photo_front==='') return this.Toast('请选择负责人证件头像面~');
      if(!this.subject_principal_info.certificate_photo_back||this.subject_principal_info.certificate_photo_back==='') return this.Toast('请选择负责人证件国徽面~'); 
      if(!this.subject_principal_info.certificate_validity_date_start||this.subject_principal_info.certificate_validity_date_start==='') return this.Toast('请选择负责人证件有效开始时间~');
      if(this.isSubLongTerm!=1&&(!this.subject_principal_info.certificate_validity_date_end||this.subject_principal_info.certificate_validity_date_end==='')) return this.Toast('请选择负责人证件有效结束时间~');
      if(this.service_content_types.length<1) return this.Toast('请选择服务内容标识~');
      if(this.nrlx_details.length<1) return this.Toast('请选择互联网信息服务前置审批项~');
      if(!this.applets_principal_info.name||this.applets_principal_info.name==='') return this.Toast('请输入小程序负责人姓名~');
      if(!this.applets_principal_info.mobile||this.applets_principal_info.mobile==='') return this.Toast('请输入小程序负责人联系方式~');
      if(!this.applets_principal_info.email||this.applets_principal_info.email==='') return this.Toast('请输入小程序负责人电子邮件~');
      if(!this.applets_principal_info.emergency_contact||this.applets_principal_info.emergency_contact==='') return this.Toast('请输入小程序负责人应急联系方式~');
      if(!this.applets_principal_info.certificate_type) return this.Toast('请选择小程序负责人的证件类型~');
      if(!this.applets_principal_info.certificate_number||this.applets_principal_info.certificate_number==='') return this.Toast('请输入小程序负责人的证件号码~');
      if(this.cardHeadImg.length<1||this.cardBackImg.length<1) return this.Toast('请上传小程序负责人的证件照片~');
      if(!this.applets_principal_info.certificate_photo_front||this.applets_principal_info.certificate_photo_front==='') return this.Toast('请选择小程序负责人证件头像面~');
      if(!this.applets_principal_info.certificate_photo_back||this.applets_principal_info.certificate_photo_back==='') return this.Toast('请选择小程序负责人证件国徽面~');
      if(!this.applets_principal_info.certificate_validity_date_start||this.applets_principal_info.certificate_validity_date_start==='') return this.Toast('请选择小程序负责人证件有效开始时间~');
      if(this.isLongTerm!=1&&(!this.applets_principal_info.certificate_validity_date_end||this.applets_principal_info.certificate_validity_date_end==='')) return this.Toast('请选择小程序负责人证件有效结束时间~');
      if(this.comment===''||!this.comment) return this.$modal.msgError('请完善微信小程序信息备注~')
      this.subject_organize_info.certificate_address = this.subject_organize_info.certificate_address&&this.subject_organize_info.certificate_address!==''?this.subject_organize_info.certificate_address.trim():'';
      let nrlx_details = [];
      this.nrlx_details.forEach(item=>{
        nrlx_details.push({type: item})
      })
      let params = {
        icp_applets:{
          base_info:{
            comment: this.comment,
            nrlx_details: nrlx_details,
            service_content_types:this.service_content_types
          },
          principal_info: this.applets_principal_info
        },
        icp_subject:{
          base_info: this.subject_base_info,
          organize_info: this.subject_organize_info,
          principal_info: this.subject_principal_info
        }
      };
      params.icp_applets.principal_info.certificate_validity_date_end = this.isLongTerm!=1?this.applets_principal_info.certificate_validity_date_end:'长期';
      params.icp_subject.principal_info.certificate_validity_date_end = this.isSubLongTerm!=1?this.subject_principal_info.certificate_validity_date_end:'长期';
      applyIcpFiling(params,this.shopCode).then(res=>{
        if(res.code===200){
          this.filingDialogVisible=false;
          setTimeout(()=>{
            this.$router.push({
              path: '/filing-succes?shopCode=' + this.shopCode
            })
          },1500)
        } else {
          this.Toast(res.msg);
        }
      })
    },
    submitRevoke(){
      cancelApplyIcpFiling({shopCode:this.shopCode}).then(res=>{
        if(res.code===200){
          this.Toast('备案申请已撤销~');
        } else {
          this.Toast(res.msg);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.set-default{
  font-size: 14px;
  color: #67B4C4;
  text-align: right;
  margin: 0 20px 20px;
}
.section{
  margin-bottom: 40px;
  h3{
    font-size: 16px;
    color: #222;
    margin: 0 20px 12px;
  }
  &-base-info{
    margin-top: 20px;
  }
  &-wechat{
    h3{
      margin-bottom: 20px;
    }
  }
}
.row{
  margin: 0 20px 20px;
  &:last-child{
    margin-bottom: 0;
  }
  &-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    .row-name{
      margin-bottom: 0;
    }
    &-radio{
      font-size: 14px;
      color: #666;
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon{
        font-size: 20px;
        color: #CCCCCC;
        margin-right: 3px;
      }
      .icon-a-Selectone{
        color: #47B6C7;
      }
    }
  }
  &-col{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon-position{
      font-size: 20px;
      color: #47B6C7;
      cursor: pointer;
    }
  }
  &-name{
    line-height: 20px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  &-add-box{
    font-size: 14px;
    color: #47B6C7;
    display: flex;
    align-items: center;
    margin-top: 12px;
    cursor: pointer;
    .icon-add2{
      font-size: 20px;
      margin-right: 4px;
    }
  }
  &-cont{
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    &-col{
      align-items: center;
      justify-content: space-between;
    }
    &-select{
      width: 100%;
      border: 1px solid #D8E0F0;
      border-radius: 10px;
    }
    &-label{
      width: 120px;
      font-size: 16px;
      color: #8F8F94;
      text-align: left;
    }
    &-info{
      width: calc(100% - 120px);
      font-size: 16px;
      color: #222;
      font-weight: 500;
    }
    &-input{
      width: 100%;
      height: 48px;
      font-size: 14px;
      color: #222;
      font-weight: 500;
      text-align: left;
      border: 1px solid #D8E0F0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      box-sizing: border-box;
      border-radius: 10px;
    }
    &-textarea{
      width: 100%;
      height: auto;
      padding: 0;
      /deep/ .el-textarea__inner{
        padding: 10px;
        border: 0;
        border-radius: 10px;
      }
    }
    &-date{
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      border-radius: 10px;
      border: 1px solid #DDDDDD;
      &-picker{
        width: 146px;
      }
      &-time{
        font-size: 16px;
        color: #222;
        text-align: center;
        font-weight: bold;
      }
      &-empty{
        font-size: 16px;
        color: #999;
        text-align: center;
      }
      /deep/ .el-input__inner{
        padding-right: 0;
        font-size: 16px;
        color: #222;
        font-weight: bold;
      }
      .ctn{
        width: 40px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #222;
        font-weight: bold;
      }
    }
    .icon-delete{
      width: 20px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #567B9C;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .tag-group{
    margin-top: 10px;
    .tag-item-active{
      background: #ECF7F9;
      color: #67B4C4;
      border: 0;
    }
  }
}
.footer-btns{
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-input__inner{
  height: 48px;
  border: 0;
  border-radius: 10px;
}
.top-tips{
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 12px 0;
  font-size: 14px;
  color: #47B6C7;
  text-align: left;
  display: block;
  background: #fff;
  cursor: pointer;
}
.reason-modal{
  width: 80%;
  .form-cont{
    min-height: 100px;
    padding: 30px;
  }
  .reason{
    line-height: 24px;
    font-size: 14px;
    text-align: left;
    margin-bottom: 20px;
    &-label{
      color: #666;
      margin-bottom: 4px;
    }
    &-cont{
      color: #222;
    }
  }
}
@media screen and (max-width:750px){
  .input-group-area{
    .tit{
      line-height: 1.2rem;
      margin-bottom: .4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .h5{
        margin-bottom: 0;
      }
    }
    .area-box{
      display: flex;
      cursor: pointer;
      .area-input{
        width: 100%;
        //width: 11rem;
        height: 2.4rem;
        padding: 0 .75rem;
        // padding:0 1.65rem 0 .75rem;
        //border-radius: .5rem 0 0 .5rem;
        border-radius: .5rem;
        border: .05rem solid #ddd;
        position: relative;
        @include flex(space-between);
        @include text-overflow();
        .area-txt{
          width: 100%;
          //width: 10rem;
          height: 2.4rem;
          line-height: 2.4rem;
          font-size: .8rem;
          color: #222;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-Tick{
          font-size: .6rem;
          color: #222;
          position: absolute;
          top: .9rem;
          right: .6rem;
          color: #47B6C7;
        }
      }
      .map-btn{
        width: 3.9rem;
        height: 2.4rem;
        border-radius: 0 .5rem .5rem 0;
        border: .05rem solid #ddd;
        border-left: 0;
        @include flex();
      }
    }
    .area-select-box{
      margin: 0 20px;
      &-select{
        border: 1px solid #ddd;
      }
      .area-info{
        line-height: 1.4;
        margin: .25rem 0 .5rem;
        font-size: .75rem;
        color: #222;
        text-align: left;
      }
      .el-select{
        width: 8.2rem;
        margin-bottom: .25rem;
      }
    }
  }

  // 省市区街道弹窗列表
  .showAddressList {
      .title-bar{
        width: 100%;
        height: 4.9rem;
      }
      .titleBox {
          width: 100%;
          height: 2.7rem;
          @include flex();
          // @include fcc;
          font-size: .8rem;
          color: #999;
          background: #F4F4F4;
          padding: 0 .75rem;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          >p {
              flex: 1;
          }
          .title {
              font-size: .9rem;
              color: #222;
              text-align: center;
          }
          .confirm {
              color: #999;
              text-align: right;
              cursor: pointer;
          }
      }
      .showAddress {
        width: 100%;
        height: 2.2rem;
        font-size: .7rem;
        color: #222;
        padding: .75rem;
        box-sizing: border-box;
        position: absolute;
        top: 2.7rem;
        left: 0;
        z-index: 4;
        background: #fff;
        border-bottom: .05rem solid #ddd;
        .showArea {
          line-height: 1;
            font-size: .7rem;
            color: #222;
            @include scrollArea();
            @include flex-align();
            p {
                margin-right: .75rem;
            }
        }
      .miniStreamView{
          width:4rem;
          height:4rem;
          display: inline-block;
          background:pink;
          margin:.3rem;
      }
        .tipTxt {
            font-size: .7rem;
            color: #47B6C7;
            position: relative;
            &::after {
                content: '';
                // @include cl;
                bottom: -0.7rem;
                width: 2.35rem;
                height: .1rem;
                background: #999;
                border-radius:.1rem ;
                transition: all 0.1s;
            }
        }
    }
      .chooseList {
          // @include sc(1.6rem, $fc);
          font-size: .8rem;

          .bd {
              &::after {
                  border-color: #E5E5E5;
                  left: .75rem;
                  right: .75rem;
              }
          }
          .addressList {
              ul {
                  li {
                      padding: .5rem .75rem;
                      .items {
                        font-size: .7rem;
                        color: #222;
                        @include flex(space-between);
                          // @include fcb;
                          .checkIcon {
                            width: .7rem;
                            height: .5rem;
                              // @include fcc;
                              display: none;
                              img {
                                width: 100%;
                                height: 100%;
                              }
                              color: #47B6C7;
                          }
                          .showIcon {
                              display: block;
                          }
                      }
                  }
              }
          }
      }
  }
  .error-msg{
    line-height: 1.1rem;
    font-size: .65rem;
    color: #FF4743;
  }
  .submit-btn{
    width: 8.1rem;
    height: 2.2rem;
    line-height: 2.15rem;
    background: #47B6C7;
    border-radius: .5rem;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    margin: 0;
    // margin: 2.1rem auto 1.5rem;
  }
  .jump-btn{
    line-height: 1.4;
    font-size: .8rem;
    color: #47B6C7;
    text-align: center;
    display: block;
    margin-left: .6rem;
  }
}


@media screen and (min-width:750px){
  .reason-modal{
    width: 345px;
    top: 35%;
  }
  .input-group-area{
    .row{
      &-col{
        margin-bottom: 8px;
      }
      &-name{
        margin-bottom: 0;
      }
    }
    .area-box{
      display: flex;
      cursor: pointer;
      .area-input{
        width: 220px;
        height: 48px;
        padding: 0 15px;
        // padding:0 33px 0 15px;
        border-radius: 10px 0 0 10px;
        border: 1px solid #ddd;
        position: relative;
        @include flex(space-between);
        @include text-overflow();
        .area-txt{
          width: 200px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #222;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-Tick{
          font-size: 12px;
          color: #222;
          position: absolute;
          top: 18px;
          right: 12px;
          color: #47B6C7;
        }
      }
      .map-btn{
        width: 78px;
        height: 48px;
        border-radius: 0 10px 10px 0;
        border: 1px solid #ddd;
        border-left: 0;
        @include flex();
      }
    }
    .area-select-box{
      display: flex;
      flex-wrap: wrap;
      &-select{
        border: 1px solid #ddd;
        border-radius: 8px;
        margin-right: 3px;
        &:nth-child(2n+2){
          margin-right: 0px;
        }
      }
      .area-info{
        line-height: 1.4;
        margin: 5px 0 10px;
        font-size: 15px;
        color: #222;
        text-align: left;
      }
      .el-select{
        width: 164px;
        margin-bottom: 5px;
      }
    }
  }

  // 省市区街道弹窗列表
  .showAddressList {
      .title-bar{
        width: 100%;
        height: 98px;
      }
      .titleBox {
          width: 100%;
          height: 54px;
          @include flex();
          // @include fcc;
          font-size: 16px;
          color: #999;
          background: #F4F4F4;
          padding: 0 15px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          >p {
              flex: 1;
          }
          .title {
              font-size: 18px;
              color: #222;
              text-align: center;
          }
          .confirm {
              color: #999;
              text-align: right;
              cursor: pointer;
          }
      }
      .showAddress {
        width: 100%;
        height: 44px;
        font-size: 14px;
        color: #222;
        padding: 15px;
        box-sizing: border-box;
        position: absolute;
        top: 54px;
        left: 0;
        z-index: 4;
        background: #fff;
        border-bottom: 1px solid #ddd;
        .showArea {
          line-height: 1;
            font-size: 14px;
            color: #222;
            @include scrollArea();
            @include flex-align();
            p {
                margin-right: 15px;
            }
        }
      .miniStreamView{
          width:80px;
          height:80px;
          display: inline-block;
          background:pink;
          margin:6px;
      }
        .tipTxt {
            font-size: 14px;
            color: #47B6C7;
            position: relative;
            &::after {
                content: '';
                // @include cl;
                bottom: -14px;
                width: 47px;
                height: 2px;
                background: #999;
                border-radius:2px ;
                transition: all 0.1s;
            }
        }
    }
      .chooseList {
          // @include sc(32px, $fc);
          font-size: 16px;

          .bd {
              &::after {
                  border-color: #E5E5E5;
                  left: 15px;
                  right: 15px;
              }
          }
          .addressList {
              ul {
                  li {
                      padding: 10px 15px;
                      .items {
                        font-size: 14px;
                        color: #222;
                        @include flex(space-between);
                          // @include fcb;
                          .checkIcon {
                            width: 14px;
                            height: 10px;
                              // @include fcc;
                              display: none;
                              img {
                                width: 100%;
                                height: 100%;
                              }
                              color: #47B6C7;
                          }
                          .showIcon {
                              display: block;
                          }
                      }
                  }
              }
          }
      }
  }
  .error-msg{
    line-height: 22px;
    font-size: 13px;
    color: #FF4743;
  }
  .submit-btn{
    width: 162px;
    height: 44px;
    line-height: 43px;
    background: #47B6C7;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    margin: 0;
    // margin: 42px auto 30px;
  }
  .jump-btn{
    line-height: 1.4;
    font-size: 16px;
    color: #47B6C7;
    text-align: center;
    display: block;
    margin-left: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/filing.vue